export const StarFilled = () => (
  <svg
    enableBackground="new 0 0 16 16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="#FFFFFF"
    aria-hidden="true"
  >
    <path d="m8.3 2.2c-.1-.2-.4-.2-.6 0l-1.5 3.5c0 .1-.1.2-.2.2l-3.7.4c-.3.1-.4.4-.2.6l2.7 2.6c.1.1.1.2.1.3l-.7 3.8c-.1.3.2.5.4.3l3.2-1.9c.1-.1.2-.1.3 0l3.2 1.9c.2.1.5-.1.4-.3l-.7-3.8c0-.1 0-.2.1-.3l2.7-2.6c.2-.2.1-.5-.2-.6l-3.7-.5c-.1 0-.2-.1-.2-.2z" />
  </svg>
);

export const StarHalf = () => (
  <svg
    enableBackground="new 0 0 16 16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="#FFFFFF"
    aria-hidden="true"
  >
    <path
      d="m13.9 6.9c.2-.2.1-.5-.2-.6l-3.7-.5c-.1 0-.2-.1-.2-.2l-1.5-3.4c-.1-.1-.2-.2-.3-.2v10h.1l3.2 1.9c.2.1.5-.1.4-.3l-.7-3.8c0-.1 0-.2.1-.3z"
      fill="#424842"
    />
    <path d="m7.7 2.2-1.5 3.5c0 .1-.1.2-.2.2l-3.7.4c-.3.1-.4.4-.2.6l2.7 2.6c.1.1.1.2.1.3l-.7 3.8c-.1.3.2.5.4.3l3.2-1.9h.1v-10s-.1.1-.2.2z" />
  </svg>
);
